import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    amount: String,
    publishableKey: String
  }

  connect() {
    this.waitForStripe()
  }

  waitForStripe() {
    const intervalId = setInterval(() => {
      if (typeof Stripe !== 'undefined') {
        clearInterval(intervalId)
        this.initializeStripeElements()
      } else {
        console.log('Waiting for Stripe to be defined...')
      }
    }, 100)
  }

  initializeStripeElements() {
    const stripe = Stripe(this.publishableKeyValue)
    const appearance = this.appearanceSettings()
    const elements = stripe.elements({appearance})
    const options = {
      amount: parseInt(this.amountValue),
      currency: 'USD',
      countryCode: 'US',
      paymentMethodTypes: ['affirm']
    }
    const affirmElement = elements.create('paymentMethodMessaging', options)
    affirmElement.mount(`#${this.element.id}`)
  }

  // TODO: update the appearance
  // https://docs.stripe.com/payments/payment-method-messaging#appearance
  // https://docs.stripe.com/elements/appearance-api
  appearanceSettings() {
    return {
      variables: {
        fontSizeBase: '16px',
        spacingUnit: '10px',
        fontWeightMedium: 'bolder'
      },
      rules: {
        '.PaymentMethodMessaging': {
          textAlign: 'center'
        }
      }
    }
  }
}
